function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#00a09b;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M507.69,336.88h60a10.15,10.15,0,0,1,8.44-4.4h9.34l1.13-3.48H507.69a3.94,3.94,0,0,0,0,7.88Z",
  transform: "translate(-488 -320)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "108.86 52.31 111.31 52.31 110.09 51.42 108.86 52.31"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M577.62,356.56l-7.56-5.49a10.72,10.72,0,0,1-.9-.74l6.57,12Z",
  transform: "translate(-488 -320)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M605.65,376.91l-.91-.66H591.45l-.91.66a10.16,10.16,0,0,1-6,2h0a10.23,10.23,0,0,1-6-2c-.28-.21-.55-.42-.81-.65H488v3.94a15.71,15.71,0,0,0,11.81,15.19v51.74h-7.87a3.94,3.94,0,0,0,0,7.88H610.06a3.94,3.94,0,1,0,0-7.88h-7.87V395.38A15.71,15.71,0,0,0,614,380.19v-1.58A10.21,10.21,0,0,1,605.65,376.91Zm-74.34,70.21H507.69V395.38a15.71,15.71,0,0,0,11.81-15.19,15.71,15.71,0,0,0,11.81,15.19Zm63,0H535.25V395.94A15.74,15.74,0,0,0,551,380.19a15.75,15.75,0,1,0,31.5,0,15.71,15.71,0,0,0,11.81,15.19Z",
  transform: "translate(-488 -320)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M519.5,411.69a3.92,3.92,0,0,0,2,3.34v9.07a3.9,3.9,0,0,0-2,3.34,3.94,3.94,0,1,0,7.88,0,3.88,3.88,0,0,0-2-3.34V415a3.91,3.91,0,1,0-5.91-3.34Z",
  transform: "translate(-488 -320)"
});

var _ref8 =
/*#__PURE__*/
React.createElement("rect", {
  className: "cls-1",
  x: 553.32,
  y: 408.09,
  width: 15.75,
  height: 3.94,
  transform: "translate(-613.59 196.89) rotate(-45)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("rect", {
  className: "cls-1",
  x: 551.01,
  y: 413.66,
  width: 31.5,
  height: 3.94,
  transform: "translate(-615.9 202.46) rotate(-45)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M574.47,366.39a2,2,0,0,1-1.57-1l-8.61-15.75a2,2,0,0,1,.78-2.67,2,2,0,0,1,1.59-.13,10.2,10.2,0,0,1-.65-6H503.75L488,372.31h86.88A10.09,10.09,0,0,1,574.47,366.39Zm-53.2-16.83-7.88,15.75a2,2,0,1,1-3.52-1.75l7.88-15.75a2,2,0,0,1,3.52,1.75Zm15.75,0-7.88,15.75a2,2,0,1,1-3.52-1.75l7.88-15.75a2,2,0,0,1,3.52,1.75Zm16,14.88a2,2,0,1,1-3.94,0V348.69a2,2,0,0,1,3.94,0Z",
  transform: "translate(-488 -320)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("rect", {
  className: "cls-1",
  x: 564.45,
  y: 419.22,
  width: 15.75,
  height: 3.94,
  transform: "translate(-618.2 208.03) rotate(-45)"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M626.52,340.66a6.76,6.76,0,0,0-6.44-4.68h-11.6a.38.38,0,0,1-.36-.26l-3.59-11.05a6.78,6.78,0,0,0-12.88,0l-3.59,11.05a.37.37,0,0,1-.36.26H576.1a6.77,6.77,0,0,0-4,12.25l9.39,6.83a.37.37,0,0,1,.14.42l-3.59,11a6.67,6.67,0,0,0,2.46,7.57,6.66,6.66,0,0,0,8,0l9.39-6.82a.36.36,0,0,1,.44,0l9.39,6.82a6.77,6.77,0,0,0,10.42-7.57l-3.59-11a.39.39,0,0,1,.14-.42l9.39-6.82A6.77,6.77,0,0,0,626.52,340.66Zm-6.21,2.39-9.39,6.83a6.72,6.72,0,0,0-2.46,7.56l3.58,11a.38.38,0,0,1-.58.42l-9.39-6.81a6.72,6.72,0,0,0-8,0l-9.39,6.82a.39.39,0,0,1-.44,0,.39.39,0,0,1-.14-.42l3.59-11.05a6.74,6.74,0,0,0-2.46-7.56l-9.39-6.83a.37.37,0,0,1,.22-.68h11.6a6.76,6.76,0,0,0,6.45-4.67l3.58-11.05c.08-.21.65-.21.72,0l3.59,11a6.73,6.73,0,0,0,6.44,4.68h11.6a.32.32,0,0,1,.36.26A.31.31,0,0,1,620.31,343.05Z",
  transform: "translate(-488 -320)"
});

var SvgStoreFavourites = function SvgStoreFavourites(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Laag_1",
    "data-name": "Laag 1",
    viewBox: "0 0 138.85 135",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStoreFavourites, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/store_favourites.9e1a0f3f.svg";
export { ForwardRef as ReactComponent };